import React, { useEffect, useState } from "react";
import {
  CCard,
  CCardBody,
  CCol,
  CFormInput,
  CFormSelect,
  CRow,
  CTable,
  CCardHeader,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CButton,
} from "@coreui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "src/components/Tooltip";
import ReactPaginate from "react-js-pagination";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { getInterest } from "src/api/allApis";
import ProductAddForm from "../ProductAddForm";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
import { refreshInterestList } from "src/redux/actions/loanListAction";
import { useDispatch } from "react-redux";
import { CSVLink } from "react-csv";
import {
  COMPANY_AddLogo,
  COMPANY_Address,
  COMPANY_NAME,
} from "src/services/const";

const ProductList = () => {
  const dispatch = useDispatch();
  const componentPDF = useRef();
  const { addData, updateData, productUpdatedData } = useSelector(
    (state) => state?.interestsReducer
  );
  const { deletedData } = useSelector((state) => state?.companyReducer);
  const [showAccordion, setShowAccordion] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showAddButton, setShowAddButton] = useState(true);
  const [showSelectAndSearch, setShowSelectAndSearch] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [interestData, setInterestData] = useState([]);
  const SchemaName = sessionStorage.getItem("schemaName");
  const [currItem, setCurrItem] = useState({});
  const [searchInput, setSearchInput] = useState("");
  const [printState, setPrintState] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const roleTy = sessionStorage.getItem("role");


  useEffect(() => {
    if (printState) {
      generatePDF();
    }
  }, [printState]);

  useEffect(() => {
    getAllInterestList();
    dispatch(refreshInterestList());
  }, [addData, updateData, productUpdatedData, deletedData]);

  const getAllInterestList = () => {
    const payload = { schemaName: SchemaName };
    getInterest(payload).then((res) => {
      setInterestData(res.data);
    });
  };

  const handleShowAddForm = (details) => {
    setShowAddForm(true);
    setShowAddButton(false);
    setShowSelectAndSearch(false);
    setCurrItem(details);
    setShowEdit(false);
  };

  const download_btn = () => {
    setPrintState(true);
  };
  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "userData",
    onAfterPrint: () => setPrintState(false),
  });

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = interestData?.slice(indexOfFirstRow, indexOfLastRow);

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const role = sessionStorage.getItem("role");

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(e.target.value);
    setCurrentPage(1);
  };

  return (
    <>
      <CRow className="content">
        {showAddForm === true ? (
          <CCard className="mb-4">
            <ProductAddForm
              setShowAddForm={setShowAddForm}
              setShowAddButton={setShowAddButton}
              setShowSelectAndSearch={setShowSelectAndSearch}
              showAddForm={showAddForm}
              intial={currItem}
              edit={showEdit}
            />
          </CCard>
        ) : (
          <CCol xs={12}>
            <CCard className="mb-4 custom-card">
              <CCardHeader className="custom-card-header">
                <h5>Loan Type</h5>
              </CCardHeader>
              <CCardBody>
                <CCard>
                  <div className="search_bar">
                    <div className="search-inner">
                      {showSelectAndSearch && (
                        <div className="select-wrapper mr-10">
                          <CFormSelect
                            size="sm"
                            className="mb-3 custom-form-input"
                            style={{ cursor: "pointer" }}
                            aria-label="Small select example"
                            onChange={handleRowsPerPageChange}
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </CFormSelect>
                        </div>
                      )}
                      <div
                        className="search-wrapper"
                        style={{ display: "flex" }}
                      >
                        {showSelectAndSearch && (
                          <>
                            <CFormInput
                              type="text"
                              size="sm"
                              placeholder="Search"
                              aria-label="sm input example"
                              style={{ margin: "0px 0px 16px 0px" }}
                              onChange={handleSearchChange}
                              value={searchInput}
                              className="custom-form-input"
                            />

                            <span className="search-icon">
                              <i className="fa fa-search"></i>
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                    {roleTy === "company" ? (
                      <div className="btn_add mt-0 mb-14">
                        {showAddButton && (
                          <Button
                            className="add-btn w-auto plr-30 mr-10"
                            onClick={handleShowAddForm}
                          >
                            Add
                          </Button>
                        )}
                        {showAddButton && (
                          <Button
                            className="add-btn w-auto mr-10"
                            onClick={download_btn}
                          >
                            Download
                          </Button>
                        )}
                        {showAddButton && (
                          <CSVLink
                            data={currentRows === undefined ? " " : currentRows}
                            filename={"loan-table.csv"}
                          >
                            <CButton className="add-btn w-auto m-0">
                              CSV
                            </CButton>
                          </CSVLink>
                        )}
                      </div>
                    ) : roleTy === "employee" ? (
                      ""
                    ) : roleTy === "manager" ? (
                      ""
                    ) : (
                      ""
                    )}
                  </div>
                  <CCardBody>
                    <div
                      className={`new-table-container ${showAddForm ? "hidden" : ""}`}
                    >
                      <div
                        className="new-common-table-wrapper mb-2"
                        ref={printState ? componentPDF : null}
                        style={{ padding: printState ? "20px" : "0px" }}
                      >
                        {printState && (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                              background:
                                "linear-gradient(180deg, #1e2639, #222b40, #4c5a7a, #7c90c2)",
                              padding: "20px",
                            }}
                          >
                            <img
                              src={COMPANY_AddLogo}
                              alt="Logo"
                              width="50px"
                              height="50px"
                            />
                            <p style={{ color: "#FFF" }}>Product List</p>
                            <div style={{ textAlign: "start" }}>
                              <p
                                style={{
                                  fontWeight: "bold",
                                  color: "#FFF",
                                  fontSize: "20px",
                                }}
                              >
                                {COMPANY_NAME}
                              </p>
                              <p
                                style={{ color: "#FFF" }}
                              >{`(${COMPANY_Address})`}</p>
                            </div>
                          </div>
                        )}
                        <CTable
                          className="custom-tablee"
                          style={{ marginTop: "20px" }}
                          hover
                          responsive
                        >
                          <CTableHead>
                            <CTableRow>
                              <CTableHeaderCell
                                scope="col"
                                className="col-md-2"
                              >
                                S. No.
                              </CTableHeaderCell>
                              <CTableHeaderCell
                                scope="col"
                                className="col-md-4"
                              >
                                Loan Type
                              </CTableHeaderCell>
                              <CTableHeaderCell
                                scope="col"
                                className="col-md-4"
                              >
                                Mobile Price
                              </CTableHeaderCell>
                              <CTableHeaderCell
                                scope="col"
                                className="col-md-4"
                              >
                                Down Payment
                              </CTableHeaderCell>
                              <CTableHeaderCell
                                scope="col"
                                className="col-md-4"
                              >
                                Rate
                              </CTableHeaderCell>
                              <CTableHeaderCell
                                scope="col"
                                className="col-md-4"
                              >
                                Status
                              </CTableHeaderCell><CTableHeaderCell
                                scope="col"
                                className="col-md-4"
                              >
                                File Charges
                              </CTableHeaderCell><CTableHeaderCell
                                scope="col"
                                className="col-md-4"
                              >
                                Other Charges
                              </CTableHeaderCell>
                              {role === "manager"
                                ? ""
                                : !printState && (
                                  <CTableHeaderCell
                                    scope="col"
                                    className="col-md-2"
                                  >
                                    Action
                                  </CTableHeaderCell>
                                )}
                            </CTableRow>
                          </CTableHead>
                          <CTableBody>
                            {interestData && interestData.length > 0 ? (
                              currentRows
                                ?.filter((item) =>
                                  item.loanType
                                    .toLowerCase()
                                    .includes(searchInput.toLowerCase())
                                )
                                .map((item, index) => {
                                  return (
                                    <CTableRow key={index}>
                                      <CTableDataCell>
                                        {indexOfFirstRow + index + 1}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {item.loanType}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {item?.price}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {item?.down_payment}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {item.rate}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {item.is_active === 1 ? "Active" : "Inactive"}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {item.file_charges}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {item.other_charges}
                                      </CTableDataCell>
                                      {role === "manager"
                                        ? ""
                                        : !printState && (
                                          <CTableDataCell className="col-md-3">
                                            <>
                                              <Tooltip text="Update">
                                                <FontAwesomeIcon
                                                  role="button"
                                                  icon={faPenToSquare}
                                                  size="1x"
                                                  onClick={() => {
                                                    handleShowAddForm(item);
                                                    setShowEdit(true);
                                                  }}
                                                  className="px-3 updateIcon"
                                                />
                                              </Tooltip>
                                            </>
                                          </CTableDataCell>
                                        )}
                                    </CTableRow>
                                  );
                                })
                            ) : (
                              <div className="loading_data">Loading...</div>
                            )}
                          </CTableBody>
                        </CTable>
                      </div>
                      <div
                        style={{
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="pagin-div">
                          <div>
                            Showing {indexOfFirstRow + 1} to{" "}
                            {Math?.min(indexOfLastRow, interestData?.length)} of{" "}
                            {interestData?.length} entries
                          </div>
                          <div className="pagination-container">
                            <ReactPaginate
                              activePage={currentPage}
                              itemsCountPerPage={rowsPerPage}
                              totalItemsCount={interestData?.length}
                              pageRangeDisplayed={5}
                              onChange={handlePageChange}
                              prevPageText="Previous"
                              nextPageText="Next"
                              firstPageText="First"
                              lastPageText="Last"
                              innerClass="pagination"
                              itemClass="page-item"
                              linkClass="page-link"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </CCardBody>
                </CCard>
              </CCardBody>
            </CCard>
          </CCol>
        )}
      </CRow>
    </>
  );
};

export default ProductList;
